module.exports = __webpack_public_path__ + "ec290fee1ce859b72f166dad33a283d1.svg";